import { Loader } from "@googlemaps/js-api-loader";
import placeTypeToZoomLevel from "./dictionaries";

class GoogleMap {
    constructor(key) {
        this.loader = new Loader({
            apiKey: key,
            version: "weekly",
            libraries: ["places"],
        });
    }

    makeAutocomplete(input, name) {
        this.loader.load().then(() => {
            const autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: { country: "cl" },
                fields: [
                    "address_components",
                    "geometry",
                    "formatted_address",
                    "vicinity",
                    "types",
                ],
                origin: { lat: -33.4184409, lng: -70.6811611 },
                strictBounds: false,
                types: [],
            });

            autocomplete.addListener("place_changed", () => {
                input.focus();
                this.search(autocomplete.getPlace(), input);
            });
        });
        this.name = name;
    }

    search(place, input) {
        const tempCenter = [
            place.geometry.location.lng(),
            place.geometry.location.lat(),
        ];
        const zoom =
            placeTypeToZoomLevel[place.types[0]] ||
            placeTypeToZoomLevel[place.types[1]] ||
            placeTypeToZoomLevel[place.types[2]] ||
            13;
        localStorage.setItem("zoom", zoom);

        const search = window.location.search;
        const data = {
            center: tempCenter,
            search: place.formatted_address,
            name: this.name,
            params: search.substring(1) || null,
            address_components: place.address_components,
        };

        if (this.name == "home") {
            const event = new CustomEvent("search-autocomplete-params", {
                detail: data,
            });
            return window.dispatchEvent(event);
        }
        if (this.name == "onboarding") {
            const event = new CustomEvent("onboarding-autocomplete", {
                detail: data,
            });
            return window.dispatchEvent(event);
        }else if(this.name == "onboarding-owner") {
            const event = new CustomEvent("onboarding-autocomplete-owner", {
                detail: data,
            });
            return window.dispatchEvent(event);
        }else if(this.name == "onboarding-keys") {
            const event = new CustomEvent("onboarding-autocomplete-keys", {
                detail: data,
            });
            return window.dispatchEvent(event);
        }
        const event = new CustomEvent("search-autocomplete", { detail: data });
        window.dispatchEvent(event);

        setTimeout(function () {
            // input.value = "";
            input.blur();
        }, 3000);
    }
}

export default GoogleMap;
